var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31716_6048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.859 14.7455C13.859 15.4473 11.4809 16.0142 8.55036 16.0142C5.61986 16.0142 3.2417 15.4473 3.2417 14.7455C3.2417 14.1184 5.14713 13.6022 7.64589 13.4961H9.45483C11.956 13.6022 13.859 14.1184 13.859 14.7455Z",
    fill: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55151 0.577148C5.82603 0.577148 3.6167 2.78407 3.6167 5.50955C3.6167 8.23503 8.55151 14.7448 8.55151 14.7448C8.55151 14.7448 13.4839 8.23503 13.4839 5.50955C13.4839 2.78407 11.277 0.577148 8.55151 0.577148ZM8.55151 8.7753C6.74739 8.7753 5.28576 7.31367 5.28576 5.50955C5.28576 3.70542 6.74739 2.24379 8.55151 2.24379C10.3556 2.24379 11.8173 3.70542 11.8173 5.50955C11.8173 7.31367 10.3556 8.7753 8.55151 8.7753Z",
    fill: "#E82327"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31716_6048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4364,
    height: 15.4364,
    fill: "white",
    transform: "translate(0.833496 0.577148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.db931a8853e516a2397c0588043c1fe1.svg";
export { ForwardRef as ReactComponent };